import React from 'react';
import { spinnerContainer, spinner } from './Spinner.css';

function Spinner() {
  return (
    <div className={spinnerContainer}>
      <div className={spinner} />
    </div>
  );
}

export default Spinner;
